module.exports = __webpack_public_path__ + "static/Tsoren-79e309823979bfcf3ca680b94d4bfde6.png";